<template>
  <section class="content">
    <div class="form-steps-outer quote-uploads">
      <div class="col-xs-12">
        <div class="text-center">
          <h2>Quote Uploads - CSV or XLSX</h2>
        </div>
      </div>
      <div class="upload-outer">
        <parse-to-json
          v-on:parse-start="parsing"
          v-on:parse-complete="parsedForOpti"
        ></parse-to-json>
      </div>
    </div>
    <div>
      <div class="box-header with-border">
        <h3 class="box-title">Uploads</h3>
      </div>
      <div class="box-body">
        <div class="file-upload-outer clearfix" v-for="(file, i) in uploads">
          <div v-if="file.forOpti">
            <div class="file-upload-header clearfix">
              <header>
                <div class="mass-type mass-opti">
                </div>
                <h3>{{ file.fileName }}</h3>
                <batch-labels :fileData="file.data"></batch-labels>
                <span class="load-xs">
                  <pulse-loader :size="'5px'" v-if="!file.complete"></pulse-loader>
                </span>
              </header>
              <div class="upload-buttons">
                <i class="ion ion-chevron-down" @click="file.visible = !file.visible"></i>
                <i class="fa fa-times" @click="removeFile(i)"></i>
              </div>
            </div>
            <div :class="[ file.visible ? 'open' : '', 'upload-contents' ]">
              <vue-table
                :showEdit="false"
                :showDelete="false"
                :tableData="getRequestData(file)"
                :tableTitle="'Quotes'"
                :fields="fieldsForOpti(file.fromArchive)"
              >
              </vue-table>
            </div>
            <div class="bottom-outer clearfix">
              <div class="load-md" v-if="!file.complete">
                Loading<pulse-loader :size="'9px'"></pulse-loader>
              </div>
              <div class="drop-sm">
                <parse-from-json
                  :disabled="!file.complete"
                  :json="makeOptiSpreadsheet(file)"
                  :fileName="makeFileName(file)"
                ></parse-from-json>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="file-upload-header clearfix">
              <header>
                <div class="mass-type mass-rating">
                </div>
                <h3>{{ file.fileName }}</h3>
                <span class="label-default label load-xs">
                  <pulse-loader :size="'5px'" v-if="!file.complete"></pulse-loader>
                </span>
                <span class="label-success label" v-if="file.complete">Complete</span>
                <span class="label-default label">Total {{ file.data.length }}</span>
              </header>
              <div class="upload-buttons">
                <i class="ion ion-chevron-down" @click="file.visible = !file.visible"></i>
                <i class="fa fa-times" @click="removeFile(i)"></i>
              </div>
            </div>
            <div :class="[ file.visible ? 'open' : '', 'upload-contents' ]">
              <vue-table
                :showEdit="false"
                :showDelete="false"
                :tableData="file.data"
                :tableTitle="'Quotes'"
                :fields="fieldsForRatings(file.fromArchive)"
              >
              </vue-table>
            </div>
            <div class="bottom-outer clearfix">
              <div class="load-md" v-if="!file.complete">
                Loading<pulse-loader :size="'9px'"></pulse-loader>
              </div>
              <div class="drop-sm">
                <parse-from-json
                  :disabled="!file.complete"
                  :json="file.data"
                  :fileName="file.guid"
                ></parse-from-json>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
  // @todo extract opti and rating into seperate components
  import ParseToJson from '../../helpers/ParseToJson.vue'
  import ParseFromJson from '../../helpers/ParseFromJson.vue'
  import VueTable from '../../helpers/VueTable.vue'
  import BatchLabels from './QuoteBatchLabels.vue'
  import PulseLoader from '../../helpers/PulseLoader.vue'
  import event from '../../../event.js'
  export default {
    name: 'QuoteUploads',
    props: {
      archive: {
        type: Array,
        default: () => ([])
      }
    },
    data () {
      return {
        uploads: [],
        headersForOpti: [
          'OriginTown',
          'DestinationTown',
          'ContainerType',
          'GoodsType',
          'JobType',
          'WeightNetLbs',
          'MinCost'
        ]
      }
    },
    components: {
      ParseToJson,
      ParseFromJson,
      VueTable,
      BatchLabels,
      PulseLoader
    },
    methods: {
      fieldsForRatings (fromArchive = false) {
        return [
          {
            header: 'Reference',
            prop: fromArchive ? 'reference' : 'Reference'
          },
          {
            header: 'Option',
            prop: fromArchive ? 'option' : 'Option'
          },
          {
            header: 'Cost',
            prop: fromArchive ? 'cost' : 'Cost',
            showLoadIfNull: true
          },
          {
            header: 'Provider',
            prop: fromArchive ? 'provider' : 'Provider',
            showLoadIfNull: true
          },
          {
            header: 'Service',
            prop: fromArchive ? 'service' : 'Service'
          },
          {
            header: 'Origin',
            prop: fromArchive ? 'originTown' : 'OriginTown'
          },
          {
            header: 'Destination',
            prop: fromArchive ? 'destinationTown' : 'DestinationTown'
          },
          {
            header: 'Container Type',
            prop: fromArchive ? 'containerType' : 'ContainerType'
          },
          {
            header: 'Goods Type',
            prop: fromArchive ? 'goodsType' : 'GoodsType'
          },
          {
            header: 'Job Type',
            prop: fromArchive ? 'jobType' : 'JobType'
          },
          {
            header: 'Weight (NET Lbs)',
            prop: fromArchive ? 'weightNetLbs' : 'WeightNetLbs'
          }
        ]
      },
      fieldsForOpti (fromArchive = false) {
        return [
          {
            header: 'Min. cost',
            prop: 'MinCost',
            showLoadIfNull: true
          },
          {
            header: 'Origin',
            prop: fromArchive ? 'originTown' : 'OriginTown'
          },
          {
            header: 'Destination',
            prop: fromArchive ? 'destinationTown' : 'DestinationTown'
          },
          {
            header: 'Container Type',
            prop: fromArchive ? 'containerType' : 'ContainerType'
          },
          {
            header: 'Goods Type',
            prop: fromArchive ? 'goodsType' : 'GoodsType'
          },
          {
            header: 'Job Type',
            prop: fromArchive ? 'jobType' : 'JobType'
          },
          {
            header: 'Weight (NET Lbs)',
            prop: fromArchive ? 'weightNetLbs' : 'WeightNetLbs'
          }
        ]
      },
      getRequestData (file) {
        return file.data.map(({request}) => request)
      },
      makeFileName (file) {
        if (this.isCSV(file.fileName)) {
          return file.fileName.substring(0, file.fileName.length - 4) + '-results'
        } else if (this.isXLSX(file.fileName)) {
          return file.fileName.substring(0, file.fileName.length - 5) + '-results'
        }
      },
      isCSV (name) {
        return name.substr(name.length - 4) === '.csv'
      },
      isXLSX (name) {
        return name.substr(name.length - 5) === '.xlsx'
      },
      cleanseForOpti ({ fileName, data }) {
        let toFloat = ['ACW', 'Density', 'VolumeNetCbm', 'VolumeGrsCbm', 'VolumeGrsCuf', 'VolumeNetCuf', 'WeightGrsKgs', 'WeightGrsLbs', 'WeightNetKgs', 'WeightNetLbs']
        let toInt = ['User']
        let segmentData = ['Segment', 'ExpenseType', 'From', 'To', 'Carrier/Vendor', 'Per 100Lbs', 'Rate', 'Transit Days']
        return {
          forOpti: true,
          fileName,
          data: data.map(obj => {
            let temp = {
              guid: window.guid(),
              request: {},
              response: {}
            }
            for (let prop in obj) {
              let val = obj[prop]
              if (toFloat.includes(prop) && obj[prop]) {
                val = parseFloat(obj[prop])
              } else if (toInt.includes(prop) && obj[prop]) {
                val = parseInt(obj[prop])
              }
              temp.request[prop] = val
            }
            segmentData.forEach(prop => {
              temp.request[prop] = null
            })
            temp.request.Originator = 'mai-opti'
            temp.request.MaxNumberOfOptions = 1
            return temp
          })
        }
      },
      parsing () {
        event.$emit('loading-on', { title: 'Parsing quote upload' })
      },
      isOpti (file) {
        return file.data.length && !file.data[0].hasOwnProperty('Service')
      },
      runOpti (file) {
        let cleansedFile = this.cleanseForOpti(file)
        event.$emit('loading-off', {})
        let fileGuid = window.guid()
        this.tempBatchRequest(fileGuid, cleansedFile.data)
        cleansedFile.data = cleansedFile.data.map(obj => {
          return {
            guid: obj.guid,
            request: {
              ...obj.request,
              MinCost: null
            }
          }
        })
        this.uploads.unshift({ ...cleansedFile, guid: fileGuid, complete: false, visible: true })
      },
      cleanseForRates ({ fileName, data }) {
        let toFloat = ['ACW', 'Density', 'VolumeNetCbm', 'VolumeGrsCbm', 'VolumeGrsCuf', 'VolumeNetCuf', 'WeightGrsKgs', 'WeightGrsLbs', 'WeightNetKgs', 'WeightNetLbs']
        let toInt = ['User']
        return {
          forOpti: false,
          fileName,
          data: data.map(obj => {
            let temp = {
              guid: window.guid(),
              request: {},
              response: {}
            }
            for (let prop in obj) {
              let val = obj[prop]
              if (toFloat.includes(prop) && obj[prop]) {
                val = parseFloat(obj[prop])
              } else if (toInt.includes(prop) && obj[prop]) {
                val = parseInt(obj[prop])
              }
              temp.request[prop] = val
            }
            temp.request.Originator = 'mai-opti'
            temp.request.MaxNumberOfOptions = 16
            return temp
          })
        }
      },
      runRates (file) {
        let cleansedFile = this.cleanseForRates(file)
        event.$emit('loading-off', {})
        let fileGuid = window.guid()
        this.tempBatchRatingRequest(fileGuid, cleansedFile.data)
        cleansedFile.data = []
        this.uploads.unshift({ ...cleansedFile, guid: fileGuid, complete: false, visible: true, archive: [] })
      },
      updateFileStatus (fileGuid) {
        let upload = this.uploads.find(({guid}) => guid === fileGuid)
        upload.complete = true
        this.$nextTick(() => this.$emit('mass-upload-complete', upload))
      },
      addResponse (fileGuid, req, data) {
        if (data.option.length) {
          let upload = this.uploads.find(({guid}) => guid === fileGuid)
          data.option.forEach(option => {
            console.log(req)
            const value = { ...req, Option: option.optionNumber, Cost: option.reportingCurrencyRate, Provider: option.serviceProvider }
            upload.data.push(value)
          })
          console.log(upload.data)
          upload.archive.push({ request: req, response: data })
        }
      },
      tempBatchRatingRequest (fileGuid, reqs) {
        let responses = 0
        reqs.forEach(req => {
          this.$store.dispatch('quote/sendWorkbenchRequest', { ...req.request, OriginalRateIdentifier: '' })
            .then(({data}) => {
              this.addResponse(fileGuid, req.request, data)
            }).catch(err => {
              console.log(err)
            }).then(() => {
              responses++
              if (responses === reqs.length) {
                this.updateFileStatus(fileGuid)
              }
            })
        })
      },
      parsedForOpti (file) {
        if (this.isOpti(file)) {
          this.runOpti(file)
        } else {
          this.runRates(file)
        }
      },
      getHeadersFromFile (dataArray) {
        let headers = []
        if (dataArray.length) {
          for (let prop in dataArray[0]) {
            headers.push(prop)
          }
        }
        return headers
      },
      getMin (response) {
        return response.option.length ? parseFloat(response.option[0].optionTotal.toFixed(2)) : 'NO ROUTES'
      },
      getMax (response) {
        return response.option.length ? parseFloat(response.option[response.option.length - 1].optionTotal.toFixed(2)) : 'NO ROUTES'
      },
      updateCosts (guid, response, error) {
        this.uploads.forEach(({data}) => {
          data.forEach(row => {
            if (row.guid === guid) {
              try {
                this.$set(row, 'response', error ? {} : response)
              } catch (e) {
                this.$set(row, 'response', {})
              }
              try {
                this.$set(row.request, 'MinCost', error ? response : this.getMin(response))
              } catch (e) {
                this.$set(row.request, 'MinCost', 'Error in processing')
              }
            }
          })
        })
      },
      checkForCompleteFile (fileGuid) {
        const max = this.uploads.length
        for (let i = 0; i !== max; i++) {
          if (this.uploads[i].guid === fileGuid) {
            const jMax = this.uploads[i].data.length
            let isComplete = true
            for (let j = 0; j !== jMax; j++) {
              if (this.uploads[i].data[j].request.MinCost === null && this.uploads[i].data[j].request.MinCost === null) {
                isComplete = false
                break
              }
            }
            this.uploads[i].complete = isComplete
            if (isComplete) {
              this.$nextTick(() => this.$emit('mass-upload-complete', this.uploads[i]))
            }
            break
          }
        }
      },
      removeFile (i) {
        this.uploads.splice(i, 1)
      },
      makeOptiSpreadsheet (file) {
        let arr = []
        file.data.forEach(o => {
          arr.push(o.request)
          if (this.responseHasOptions(o)) {
            o.response.option[0].item.forEach(item => {
              arr.push(this.makeSegmentEntry(o.request, item))
            })
          }
        })
        return arr
      },
      responseHasOptions (o) {
        return o.hasOwnProperty('response') && o.response.hasOwnProperty('option') && o.response.option && o.response.option.length > 0
      },
      makeSegmentEntry (req, item) {
        let segmentData = ['Segment', 'ExpenseType', 'From', 'To', 'Carrier/Vendor', 'Per 100Lbs', 'Rate', 'Transit Days']
        let newEntry = Object.assign({}, req)
        for (let prop in newEntry) {
          newEntry[prop] = null
          newEntry.Segment = item.itemNumber
          newEntry.ExpenseType = item.service
          newEntry.From = item.details[0].from
          newEntry.To = item.details[0].to
          newEntry['Carrier/Vendor'] = item.details[0].tariffName + ' ' + item.serviceProviderName
          newEntry['Rate'] = item.rate
          newEntry['Transit Days'] = item.durationType === 'D' ? item.duration : parseFloat(item.duration / 24, 2)
          newEntry['Per 100Lbs'] = req.hasOwnProperty('WeightNetLbs') && req['WeightNetLbs'] ? parseFloat((item.rate / req['WeightNetLbs']) * 100, 2) : null
        }
        return newEntry
      },
      tempBatchRequestz (f, data) {
        this.$store.dispatch('quote/getMultiRates', data.map(req => req.request))
        .then(({data}) => console.log(data)).catch(err => console.log(err))
      },
      tempBatchRequest (fileGuid, data) {
        data.forEach(req => {
          this.$store.dispatch('quote/sendRateRequest', req.request)
            .then(res => {
              this.updateCosts(req.guid, res, false)
              this.checkForCompleteFile(fileGuid)
            }).catch(err => {
              let errMessage
              try {
                const body = JSON.parse(err)
                errMessage = body.responseNotes || 'ERROR'
              } catch (e) {
                errMessage = err
              }
              this.updateCosts(req.guid, errMessage, true)
              this.checkForCompleteFile(fileGuid)
            })
        })
      },
      updateAllCosts () {
        this.uploads.forEach(upload => {
          upload.data.forEach(({guid, request, response}) => {
            if (request) {
              this.updateCosts(guid, response, false)
            }
          })
        })
      },
      archiveToOpti (obj) {
        return {
          ...obj,
          data: obj.data.map(({request, response, guid}) => {
            return {
              request: { ...request, MinCost: null },
              response,
              guid
            }
          })
        }
      },
      archiveToRate (obj) {
        const responses = obj.data.map(({response, request}) => {
          return response.option.map(option => {
            return {
              ...request,
              ...option,
              option: option.optionNumber,
              cost: option.reportingCurrencyRate,
              provider: option.serviceProvider
            }
          })
        }).flat()
        return {
          ...obj,
          data: responses
        }
      }
    },
    mounted () {
      this.uploads = this.archive.map(obj => obj.forOpti ? this.archiveToOpti(obj) : this.archiveToRate(obj))
      this.$nextTick(this.updateAllCosts)
    }
  }
</script>

<style>
  .mass-type {
    top: -3px !important;
    left: -13px !important;
    position: absolute;
    width: 0;
    height: 0;
    border-left: 20px solid transparent;
    border-right: 20px solid transparent;
    border-bottom: 20px solid #fff;
    transform: rotate(-45deg);
  }
  .bottom-outer {
    padding: 10px;
  }
  .mass-type.mass-rating:after {
    content: 'R';
    color: #3c8dbc;
    position: absolute;
    left: -4px;
    top: 2px;
    transform: rotate(45deg);
    font-style: italic;
  }
  .mass-type.mass-opti:after {
    content: 'O';
    color: #3c8dbc;
    position: absolute;
    left: -4px;
    top: 2px;
    transform: rotate(45deg);
    font-style: italic;
  }
  .drop-sm {
    display:inline-block;
    float: right;
  }
  .load-md {
    display: inline-block;
    color: #5DC596;
    font-weight: bold;
  }
  .load-xs {
    display: inline-block;
  }
  @media (max-width: 768px) {
    .drop-sm {
      display:block;
      float: none;
    }
    .drop-sm .btn-info {
      width: 49% !important;
    }
    .load-md {
      display: none;
    }
  }
  .upload-outer {
    position: absolute;
    top: 0;
    right: 0;
  }
  .file-upload-outer {
    background:#fff;
    margin: 20px;
    -webkit-box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.53);
    -moz-box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.53);
    box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.53);
    transition: box-shadow 0.5s;
  }
  .file-upload-outer:hover {
    -webkit-box-shadow: 0px 0px 23px 0px rgba(0,0,0,0.53);
    -moz-box-shadow: 0px 0px 23px 0px rgba(0,0,0,0.53);
    box-shadow: 0px 0px 23px 0px rgba(0,0,0,0.53);
  }
  .file-upload-outer h3 {
    display: inline-block;
  }
  .file-upload-outer header {
    background: #3c8dbc;
    color: #fff;
    padding: 5px 10px;
  }
  .file-upload-outer {
    position: relative;
  }
  .upload-contents {
    max-height: 0px;
    transition: max-height 0.5s;
    overflow: hidden;
  }
  .upload-contents.open {
    max-height: 10000px;
  }
  .upload-buttons {
    position: absolute;
    top: 0;
    font-size: 20px;
    right: 5px;
  }
  .upload-buttons i {
    cursor: pointer;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// QuoteUploads.vue?62b6fed2